import React, { useMemo } from 'react';
import { getSolution } from '@/utils/server';
import { OD_APP_DEFAULT } from '@/constants/constants';

const SolutionContext = React.createContext([{}, () => {}]);

const SolutionProvider = ({ host, children }) => {
  const solution = useMemo(() => getSolution(host), [host]);

  if (!solution) {
    console.log('SolutionProvider missing config for', host);
  }

  const solutionKey = solution.solution_key;

  const constants = {
    OD_APP_DEFAULT
  };

  return (
    <SolutionContext.Provider
      value={{
        host,
        solution,
        // the isPrime and solutionKey values can be needed in some cases, but try not
        // to use in `if/else if/.../else` logic for solution detection if possible
        isPrime: solutionKey === 'prime',
        solutionKey,
        solutionName: solution.name,
        constants
      }}
    >
      {children}
    </SolutionContext.Provider>
  );
};

export { SolutionContext, SolutionProvider };
